import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api, formatApiError } from "../lib/apiClient";

const AdminAuthCtx = createContext({
  admin: null,        // null = loading, false = unauthenticated, object = authenticated
  login: async () => {},
  logout: async () => {},
  refresh: async () => {},
});

export function AdminAuthProvider({ children }) {
  const [admin, setAdmin] = useState(null);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setAdmin(data);
    } catch {
      setAdmin(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const login = useCallback(async (email, password) => {
    try {
      const { data } = await api.post("/auth/login", { email, password });
      setAdmin(data);
      return { ok: true };
    } catch (err) {
      return { ok: false, error: formatApiError(err, "Login failed") };
    }
  }, []);

  const logout = useCallback(async () => {
    try {
      await api.post("/auth/logout");
    } catch {
      /* ignore */
    }
    setAdmin(false);
  }, []);

  return (
    <AdminAuthCtx.Provider value={{ admin, login, logout, refresh }}>
      {children}
    </AdminAuthCtx.Provider>
  );
}

export function useAdminAuth() {
  return useContext(AdminAuthCtx);
}
